var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorResource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 199.7 283.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#New_Gradient_Swatch_copy_25);}.cls-3{fill:url(#New_Gradient_Swatch_copy_25-2);}.cls-151,.cls-152,.cls-308,.cls-4,.cls-5{opacity:0.2;}.cls-4{fill:url(#New_Gradient_Swatch_copy_25-3);}.cls-5{fill:url(#New_Gradient_Swatch_copy_25-4);}.cls-6{fill:url(#New_Gradient_Swatch_copy_25-5);}.cls-7{fill:url(#New_Gradient_Swatch_copy_25-6);}.cls-8{fill:url(#New_Gradient_Swatch_copy_25-7);}.cls-9{fill:url(#New_Gradient_Swatch_copy_25-8);}.cls-10{fill:url(#New_Gradient_Swatch_copy_25-9);}.cls-11{fill:url(#New_Gradient_Swatch_copy_25-10);}.cls-12{fill:url(#New_Gradient_Swatch_copy_25-11);}.cls-13{fill:url(#linear-gradient);}.cls-14{fill:url(#linear-gradient-2);}.cls-15{fill:url(#New_Gradient_Swatch_copy_8);}.cls-16{fill:url(#linear-gradient-3);}.cls-17{fill:url(#linear-gradient-4);}.cls-18{fill:url(#linear-gradient-5);}.cls-19{fill:url(#linear-gradient-6);}.cls-20{fill:url(#linear-gradient-7);}.cls-21{fill:url(#linear-gradient-8);}.cls-22{fill:url(#linear-gradient-9);}.cls-23{fill:url(#linear-gradient-10);}.cls-24{fill:url(#linear-gradient-11);}.cls-25{fill:url(#linear-gradient-12);}.cls-26{fill:url(#linear-gradient-13);}.cls-27{fill:url(#linear-gradient-14);}.cls-28{fill:url(#linear-gradient-15);}.cls-29{fill:url(#linear-gradient-16);}.cls-30{fill:url(#linear-gradient-17);}.cls-31{fill:url(#linear-gradient-18);}.cls-32{fill:url(#linear-gradient-19);}.cls-33{fill:url(#linear-gradient-20);}.cls-34{fill:url(#linear-gradient-21);}.cls-35{fill:url(#linear-gradient-22);}.cls-36{fill:url(#linear-gradient-23);}.cls-37{fill:url(#linear-gradient-24);}.cls-38{fill:url(#linear-gradient-25);}.cls-39{fill:url(#linear-gradient-26);}.cls-40{fill:url(#linear-gradient-27);}.cls-41{fill:url(#linear-gradient-28);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{fill:url(#linear-gradient-32);}.cls-46{fill:url(#linear-gradient-33);}.cls-47{fill:url(#linear-gradient-34);}.cls-48{fill:url(#linear-gradient-35);}.cls-49{fill:url(#linear-gradient-36);}.cls-50{fill:url(#linear-gradient-37);}.cls-51{fill:url(#linear-gradient-38);}.cls-52{fill:url(#linear-gradient-39);}.cls-53{fill:url(#linear-gradient-40);}.cls-54{fill:url(#linear-gradient-41);}.cls-55{fill:url(#linear-gradient-42);}.cls-56{fill:url(#linear-gradient-43);}.cls-57{fill:url(#linear-gradient-44);}.cls-58{fill:url(#linear-gradient-45);}.cls-59{fill:url(#linear-gradient-46);}.cls-60{fill:url(#linear-gradient-47);}.cls-61{fill:url(#linear-gradient-48);}.cls-62{fill:url(#linear-gradient-49);}.cls-63{fill:url(#linear-gradient-50);}.cls-64{fill:url(#linear-gradient-51);}.cls-65{fill:url(#linear-gradient-52);}.cls-66{fill:url(#linear-gradient-53);}.cls-67{fill:url(#linear-gradient-54);}.cls-68{fill:url(#linear-gradient-55);}.cls-69{fill:url(#linear-gradient-56);}.cls-70{fill:url(#linear-gradient-57);}.cls-71{fill:url(#linear-gradient-58);}.cls-72{fill:url(#linear-gradient-59);}.cls-73{fill:url(#linear-gradient-60);}.cls-74{fill:url(#linear-gradient-61);}.cls-75{fill:url(#linear-gradient-62);}.cls-76{fill:url(#linear-gradient-63);}.cls-77{fill:url(#linear-gradient-64);}.cls-78{fill:url(#linear-gradient-65);}.cls-79{fill:url(#linear-gradient-66);}.cls-80{fill:url(#linear-gradient-67);}.cls-81{fill:url(#linear-gradient-68);}.cls-82{fill:url(#linear-gradient-69);}.cls-83{fill:url(#linear-gradient-70);}.cls-84{fill:url(#linear-gradient-71);}.cls-85{fill:url(#linear-gradient-72);}.cls-86{fill:url(#linear-gradient-73);}.cls-87{fill:url(#linear-gradient-74);}.cls-88{fill:url(#linear-gradient-75);}.cls-89{fill:url(#linear-gradient-76);}.cls-90{fill:url(#linear-gradient-77);}.cls-91{fill:url(#linear-gradient-78);}.cls-92{fill:url(#linear-gradient-79);}.cls-93{fill:url(#linear-gradient-80);}.cls-94{fill:url(#linear-gradient-81);}.cls-95{fill:url(#linear-gradient-82);}.cls-96{fill:url(#linear-gradient-83);}.cls-97{fill:url(#linear-gradient-84);}.cls-98{fill:url(#linear-gradient-85);}.cls-99{fill:url(#linear-gradient-86);}.cls-100{fill:url(#linear-gradient-87);}.cls-101{fill:url(#linear-gradient-88);}.cls-102{fill:url(#linear-gradient-89);}.cls-103{fill:url(#linear-gradient-90);}.cls-104{fill:url(#linear-gradient-91);}.cls-105{fill:url(#linear-gradient-92);}.cls-106{fill:url(#linear-gradient-93);}.cls-107{fill:url(#linear-gradient-94);}.cls-108{fill:url(#linear-gradient-95);}.cls-109{fill:url(#linear-gradient-96);}.cls-110{fill:url(#linear-gradient-97);}.cls-111{fill:url(#linear-gradient-98);}.cls-112{fill:url(#linear-gradient-99);}.cls-113{fill:url(#linear-gradient-100);}.cls-114{fill:url(#linear-gradient-101);}.cls-115{fill:url(#linear-gradient-102);}.cls-116{fill:url(#linear-gradient-103);}.cls-117{fill:url(#linear-gradient-104);}.cls-118{fill:url(#linear-gradient-105);}.cls-119{fill:url(#linear-gradient-106);}.cls-120{fill:url(#linear-gradient-107);}.cls-121{fill:url(#linear-gradient-108);}.cls-122{fill:url(#linear-gradient-109);}.cls-123{fill:url(#linear-gradient-110);}.cls-124{fill:url(#linear-gradient-111);}.cls-125{fill:url(#linear-gradient-112);}.cls-126{fill:url(#linear-gradient-113);}.cls-127{fill:url(#linear-gradient-114);}.cls-128{fill:url(#linear-gradient-115);}.cls-129{fill:url(#linear-gradient-116);}.cls-130{fill:url(#linear-gradient-117);}.cls-131{fill:url(#linear-gradient-118);}.cls-132{fill:url(#linear-gradient-119);}.cls-133{fill:url(#linear-gradient-120);}.cls-134{fill:url(#linear-gradient-121);}.cls-135{fill:url(#linear-gradient-122);}.cls-136{fill:url(#linear-gradient-123);}.cls-137{fill:url(#linear-gradient-124);}.cls-138{fill:url(#linear-gradient-125);}.cls-139{fill:url(#New_Gradient_Swatch_copy_9);}.cls-140{fill:url(#New_Gradient_Swatch_copy_9-2);}.cls-141{fill:url(#New_Gradient_Swatch_copy_9-3);}.cls-142{fill:url(#New_Gradient_Swatch_copy_9-4);}.cls-143{fill:url(#New_Gradient_Swatch_copy_9-5);}.cls-144{fill:url(#New_Gradient_Swatch_copy_9-6);}.cls-145,.cls-147,.cls-148,.cls-292,.cls-294,.cls-295,.cls-307,.cls-316,.cls-317{mix-blend-mode:color-dodge;}.cls-145{fill:url(#New_Gradient_Swatch_copy_7);}.cls-146{fill:url(#New_Gradient_Swatch_copy_25-12);}.cls-147{fill:url(#linear-gradient-126);}.cls-148{fill:url(#linear-gradient-127);}.cls-149{fill:url(#New_Gradient_Swatch_copy_25-13);}.cls-150{fill:url(#New_Gradient_Swatch_copy_25-14);}.cls-151{fill:url(#New_Gradient_Swatch_copy_25-15);}.cls-152{fill:url(#New_Gradient_Swatch_copy_25-16);}.cls-153{fill:url(#New_Gradient_Swatch_copy_25-17);}.cls-154{fill:url(#New_Gradient_Swatch_copy_25-18);}.cls-155{fill:url(#New_Gradient_Swatch_copy_25-19);}.cls-156{fill:url(#New_Gradient_Swatch_copy_25-20);}.cls-157{fill:url(#New_Gradient_Swatch_copy_25-21);}.cls-158{fill:url(#New_Gradient_Swatch_copy_25-22);}.cls-159{fill:url(#New_Gradient_Swatch_copy_25-23);}.cls-160{fill:url(#linear-gradient-128);}.cls-161{fill:url(#linear-gradient-129);}.cls-162{fill:url(#New_Gradient_Swatch_copy_8-2);}.cls-163{fill:url(#linear-gradient-130);}.cls-164{fill:url(#linear-gradient-131);}.cls-165{fill:url(#linear-gradient-132);}.cls-166{fill:url(#linear-gradient-133);}.cls-167{fill:url(#linear-gradient-134);}.cls-168{fill:url(#linear-gradient-135);}.cls-169{fill:url(#linear-gradient-136);}.cls-170{fill:url(#linear-gradient-137);}.cls-171{fill:url(#linear-gradient-138);}.cls-172{fill:url(#linear-gradient-139);}.cls-173{fill:url(#linear-gradient-140);}.cls-174{fill:url(#linear-gradient-141);}.cls-175{fill:url(#linear-gradient-142);}.cls-176{fill:url(#linear-gradient-143);}.cls-177{fill:url(#linear-gradient-144);}.cls-178{fill:url(#linear-gradient-145);}.cls-179{fill:url(#linear-gradient-146);}.cls-180{fill:url(#linear-gradient-147);}.cls-181{fill:url(#linear-gradient-148);}.cls-182{fill:url(#linear-gradient-149);}.cls-183{fill:url(#linear-gradient-150);}.cls-184{fill:url(#linear-gradient-151);}.cls-185{fill:url(#linear-gradient-152);}.cls-186{fill:url(#linear-gradient-153);}.cls-187{fill:url(#linear-gradient-154);}.cls-188{fill:url(#linear-gradient-155);}.cls-189{fill:url(#linear-gradient-156);}.cls-190{fill:url(#linear-gradient-157);}.cls-191{fill:url(#linear-gradient-158);}.cls-192{fill:url(#linear-gradient-159);}.cls-193{fill:url(#linear-gradient-160);}.cls-194{fill:url(#linear-gradient-161);}.cls-195{fill:url(#linear-gradient-162);}.cls-196{fill:url(#linear-gradient-163);}.cls-197{fill:url(#linear-gradient-164);}.cls-198{fill:url(#linear-gradient-165);}.cls-199{fill:url(#linear-gradient-166);}.cls-200{fill:url(#linear-gradient-167);}.cls-201{fill:url(#linear-gradient-168);}.cls-202{fill:url(#linear-gradient-169);}.cls-203{fill:url(#linear-gradient-170);}.cls-204{fill:url(#linear-gradient-171);}.cls-205{fill:url(#linear-gradient-172);}.cls-206{fill:url(#linear-gradient-173);}.cls-207{fill:url(#linear-gradient-174);}.cls-208{fill:url(#linear-gradient-175);}.cls-209{fill:url(#linear-gradient-176);}.cls-210{fill:url(#linear-gradient-177);}.cls-211{fill:url(#linear-gradient-178);}.cls-212{fill:url(#linear-gradient-179);}.cls-213{fill:url(#linear-gradient-180);}.cls-214{fill:url(#linear-gradient-181);}.cls-215{fill:url(#linear-gradient-182);}.cls-216{fill:url(#linear-gradient-183);}.cls-217{fill:url(#linear-gradient-184);}.cls-218{fill:url(#linear-gradient-185);}.cls-219{fill:url(#linear-gradient-186);}.cls-220{fill:url(#linear-gradient-187);}.cls-221{fill:url(#linear-gradient-188);}.cls-222{fill:url(#linear-gradient-189);}.cls-223{fill:url(#linear-gradient-190);}.cls-224{fill:url(#linear-gradient-191);}.cls-225{fill:url(#linear-gradient-192);}.cls-226{fill:url(#linear-gradient-193);}.cls-227{fill:url(#linear-gradient-194);}.cls-228{fill:url(#linear-gradient-195);}.cls-229{fill:url(#linear-gradient-196);}.cls-230{fill:url(#linear-gradient-197);}.cls-231{fill:url(#linear-gradient-198);}.cls-232{fill:url(#linear-gradient-199);}.cls-233{fill:url(#linear-gradient-200);}.cls-234{fill:url(#linear-gradient-201);}.cls-235{fill:url(#linear-gradient-202);}.cls-236{fill:url(#linear-gradient-203);}.cls-237{fill:url(#linear-gradient-204);}.cls-238{fill:url(#linear-gradient-205);}.cls-239{fill:url(#linear-gradient-206);}.cls-240{fill:url(#linear-gradient-207);}.cls-241{fill:url(#linear-gradient-208);}.cls-242{fill:url(#linear-gradient-209);}.cls-243{fill:url(#linear-gradient-210);}.cls-244{fill:url(#linear-gradient-211);}.cls-245{fill:url(#linear-gradient-212);}.cls-246{fill:url(#linear-gradient-213);}.cls-247{fill:url(#linear-gradient-214);}.cls-248{fill:url(#linear-gradient-215);}.cls-249{fill:url(#linear-gradient-216);}.cls-250{fill:url(#linear-gradient-217);}.cls-251{fill:url(#linear-gradient-218);}.cls-252{fill:url(#linear-gradient-219);}.cls-253{fill:url(#linear-gradient-220);}.cls-254{fill:url(#linear-gradient-221);}.cls-255{fill:url(#linear-gradient-222);}.cls-256{fill:url(#linear-gradient-223);}.cls-257{fill:url(#linear-gradient-224);}.cls-258{fill:url(#linear-gradient-225);}.cls-259{fill:url(#linear-gradient-226);}.cls-260{fill:url(#linear-gradient-227);}.cls-261{fill:url(#linear-gradient-228);}.cls-262{fill:url(#linear-gradient-229);}.cls-263{fill:url(#linear-gradient-230);}.cls-264{fill:url(#linear-gradient-231);}.cls-265{fill:url(#linear-gradient-232);}.cls-266{fill:url(#linear-gradient-233);}.cls-267{fill:url(#linear-gradient-234);}.cls-268{fill:url(#linear-gradient-235);}.cls-269{fill:url(#linear-gradient-236);}.cls-270{fill:url(#linear-gradient-237);}.cls-271{fill:url(#linear-gradient-238);}.cls-272{fill:url(#linear-gradient-239);}.cls-273{fill:url(#linear-gradient-240);}.cls-274{fill:url(#linear-gradient-241);}.cls-275{fill:url(#linear-gradient-242);}.cls-276{fill:url(#linear-gradient-243);}.cls-277{fill:url(#linear-gradient-244);}.cls-278{fill:url(#linear-gradient-245);}.cls-279{fill:url(#linear-gradient-246);}.cls-280{fill:url(#linear-gradient-247);}.cls-281{fill:url(#linear-gradient-248);}.cls-282{fill:url(#linear-gradient-249);}.cls-283{fill:url(#linear-gradient-250);}.cls-284{fill:url(#linear-gradient-251);}.cls-285{fill:url(#linear-gradient-252);}.cls-286{fill:url(#New_Gradient_Swatch_copy_9-7);}.cls-287{fill:url(#New_Gradient_Swatch_copy_9-8);}.cls-288{fill:url(#New_Gradient_Swatch_copy_9-9);}.cls-289{fill:url(#New_Gradient_Swatch_copy_9-10);}.cls-290{fill:url(#New_Gradient_Swatch_copy_9-11);}.cls-291{fill:url(#New_Gradient_Swatch_copy_9-12);}.cls-292{fill:url(#New_Gradient_Swatch_copy_7-2);}.cls-293{fill:url(#New_Gradient_Swatch_copy_25-24);}.cls-294{fill:url(#linear-gradient-253);}.cls-295{fill:url(#linear-gradient-254);}.cls-296{fill:#bcbec0;}.cls-296,.cls-315{mix-blend-mode:multiply;}.cls-297{fill:url(#New_Gradient_Swatch_copy_9-13);}.cls-298{fill:url(#linear-gradient-255);}.cls-299{fill:url(#New_Gradient_Swatch_copy_9-14);}.cls-300{fill:url(#linear-gradient-256);}.cls-301{fill:url(#New_Gradient_Swatch_copy_9-15);}.cls-302{fill:url(#linear-gradient-257);}.cls-303{fill:url(#New_Gradient_Swatch_copy_9-16);}.cls-304{fill:url(#linear-gradient-258);}.cls-305{fill:url(#linear-gradient-259);}.cls-306{fill:url(#New_Gradient_Swatch_copy_9-17);}.cls-307{fill:url(#Radial_Gradient_1);}.cls-308{fill:url(#linear-gradient-260);}.cls-309{fill:url(#linear-gradient-261);}.cls-310{fill:url(#New_Gradient_Swatch_copy_9-18);}.cls-311{fill:url(#linear-gradient-262);}.cls-312{fill:url(#linear-gradient-263);}.cls-313{fill:url(#linear-gradient-264);}.cls-314{fill:url(#New_Gradient_Swatch_copy_18);}.cls-315{fill:url(#Linear_Gradient_1);}.cls-316{fill:url(#radial-gradient);}.cls-317{fill:url(#New_Gradient_Swatch_copy_6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25",
    x1: 76.54,
    y1: 212.21,
    x2: 256.62,
    y2: 158.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-2",
    x1: -41.58,
    y1: 233.49,
    x2: 92.56,
    y2: 203.42,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-3",
    x1: 76.54,
    y1: 221.57,
    x2: 256.62,
    y2: 167.64,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-4",
    x1: -41.58,
    y1: 242.84,
    x2: 92.56,
    y2: 212.77,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-5",
    x1: 152.7,
    y1: 26.04,
    x2: 60.05,
    y2: 202.61,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-6",
    x1: 23.53,
    y1: 105.48,
    x2: 278.57,
    y2: 29.12,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-7",
    x1: 68.42,
    y1: 134.95,
    x2: 296.29,
    y2: 66.72,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-8",
    x1: -75.47,
    y1: 162.17,
    x2: 133.17,
    y2: 115.4,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-9",
    x1: 141.55,
    y1: -96.43,
    x2: 58.77,
    y2: 61.34,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-10",
    x1: 70.85,
    y1: 133.08,
    x2: 325.88,
    y2: 56.72,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-11",
    x1: 152.7,
    y1: -125.88,
    x2: 60.05,
    y2: 50.7,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -356.92,
    y1: 1822.42,
    x2: -354.61,
    y2: 1822.42,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#169ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bb0d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -353.64,
    y1: 1822.42,
    x2: -351.32,
    y2: 1822.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8",
    x1: -360.21,
    y1: 1822.42,
    x2: -357.9,
    y2: 1822.42,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffb892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fee1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -325.65,
    y1: 1822.42,
    x2: -319.9,
    y2: 1822.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -350.35,
    y1: 1822.42,
    x2: -326.62,
    y2: 1822.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -363.75,
    y1: 1822.42,
    x2: -361.18,
    y2: 1822.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -356.92,
    y1: 1827.57,
    x2: -354.61,
    y2: 1827.57,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1a86bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#1f95c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26acd4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -353.64,
    y1: 1827.57,
    x2: -351.32,
    y2: 1827.57,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -360.21,
    y1: 1827.57,
    x2: -357.9,
    y2: 1827.57,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#faa28d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fbb194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fddaa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fee5aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -325.65,
    y1: 1827.57,
    x2: -319.9,
    y2: 1827.57,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -350.35,
    y1: 1827.57,
    x2: -326.62,
    y2: 1827.57,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -363.75,
    y1: 1827.57,
    x2: -361.18,
    y2: 1827.57,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -356.92,
    y1: 1832.72,
    x2: -354.61,
    y2: 1832.72,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2080bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#268fc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31a9d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -353.64,
    y1: 1832.72,
    x2: -351.32,
    y2: 1832.72,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -360.21,
    y1: 1832.72,
    x2: -357.9,
    y2: 1832.72,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f69b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f8aa96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fdd3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fedfac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -325.65,
    y1: 1832.72,
    x2: -319.9,
    y2: 1832.72,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -350.35,
    y1: 1832.72,
    x2: -326.62,
    y2: 1832.72,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -363.75,
    y1: 1832.72,
    x2: -361.18,
    y2: 1832.72,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -356.92,
    y1: 1837.88,
    x2: -354.61,
    y2: 1837.88,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#277bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2f8ac3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ca5d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -353.64,
    y1: 1837.88,
    x2: -351.32,
    y2: 1837.88,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -360.21,
    y1: 1837.88,
    x2: -357.9,
    y2: 1837.88,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f19490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f4a397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fccca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed8ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -325.65,
    y1: 1837.88,
    x2: -319.9,
    y2: 1837.88,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -350.35,
    y1: 1837.88,
    x2: -326.62,
    y2: 1837.88,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -363.75,
    y1: 1837.88,
    x2: -361.18,
    y2: 1837.88,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -356.92,
    y1: 1843.03,
    x2: -354.61,
    y2: 1843.03,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#2e75ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3684c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46a1d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -353.64,
    y1: 1843.03,
    x2: -351.32,
    y2: 1843.03,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -360.21,
    y1: 1843.03,
    x2: -357.9,
    y2: 1843.03,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ed8e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#f19d99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fbc6aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed2af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -325.65,
    y1: 1843.03,
    x2: -319.9,
    y2: 1843.03,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -350.35,
    y1: 1843.03,
    x2: -326.62,
    y2: 1843.03,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -363.75,
    y1: 1843.03,
    x2: -361.18,
    y2: 1843.03,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -356.92,
    y1: 1848.18,
    x2: -354.61,
    y2: 1848.18,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3470b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3e7fc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#519ed3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -353.64,
    y1: 1848.18,
    x2: -351.32,
    y2: 1848.18,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -360.21,
    y1: 1848.18,
    x2: -357.9,
    y2: 1848.18,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e88793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ed969a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fabfac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fecbb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -325.65,
    y1: 1848.18,
    x2: -319.9,
    y2: 1848.18,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -350.35,
    y1: 1848.18,
    x2: -326.62,
    y2: 1848.18,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -363.75,
    y1: 1848.18,
    x2: -361.18,
    y2: 1848.18,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -356.92,
    y1: 1853.34,
    x2: -354.61,
    y2: 1853.34,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3b6ab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4679c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c9ad2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -353.64,
    y1: 1853.34,
    x2: -351.32,
    y2: 1853.34,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -360.21,
    y1: 1853.34,
    x2: -357.9,
    y2: 1853.34,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e48095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ea8f9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f9b8ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec5b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -325.65,
    y1: 1853.34,
    x2: -319.9,
    y2: 1853.34,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -350.35,
    y1: 1853.34,
    x2: -326.62,
    y2: 1853.34,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -363.75,
    y1: 1853.34,
    x2: -361.18,
    y2: 1853.34,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -356.92,
    y1: 1858.49,
    x2: -354.61,
    y2: 1858.49,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4265b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4e74bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6796d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -353.64,
    y1: 1858.49,
    x2: -351.32,
    y2: 1858.49,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -360.21,
    y1: 1858.49,
    x2: -357.9,
    y2: 1858.49,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#df7996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e6889d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f8b1af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#febeb5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -325.65,
    y1: 1858.49,
    x2: -319.9,
    y2: 1858.49,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -350.35,
    y1: 1858.49,
    x2: -326.62,
    y2: 1858.49,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -363.75,
    y1: 1858.49,
    x2: -361.18,
    y2: 1858.49,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -356.92,
    y1: 1863.64,
    x2: -354.61,
    y2: 1863.64,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4860b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#556fbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7293d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -353.64,
    y1: 1863.64,
    x2: -351.32,
    y2: 1863.64,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -360.21,
    y1: 1863.64,
    x2: -357.9,
    y2: 1863.64,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#da7298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e2819f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f7aab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb8b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -325.65,
    y1: 1863.64,
    x2: -319.9,
    y2: 1863.64,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -350.35,
    y1: 1863.64,
    x2: -326.62,
    y2: 1863.64,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -363.75,
    y1: 1863.64,
    x2: -361.18,
    y2: 1863.64,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -356.92,
    y1: 1868.8,
    x2: -354.61,
    y2: 1868.8,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4f5ab5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#5c69bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d8fd1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -353.64,
    y1: 1868.8,
    x2: -351.32,
    y2: 1868.8,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -360.21,
    y1: 1868.8,
    x2: -357.9,
    y2: 1868.8,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d66b99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#df7aa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f6a3b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb1b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -325.65,
    y1: 1868.8,
    x2: -319.9,
    y2: 1868.8,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -350.35,
    y1: 1868.8,
    x2: -326.62,
    y2: 1868.8,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -363.75,
    y1: 1868.8,
    x2: -361.18,
    y2: 1868.8,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -356.92,
    y1: 1873.95,
    x2: -354.61,
    y2: 1873.95,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5655b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6464bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888bd1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -353.64,
    y1: 1873.95,
    x2: -351.32,
    y2: 1873.95,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -360.21,
    y1: 1873.95,
    x2: -357.9,
    y2: 1873.95,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d1649b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#db73a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f49cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feabba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -325.65,
    y1: 1873.95,
    x2: -319.9,
    y2: 1873.95,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -350.35,
    y1: 1873.95,
    x2: -326.62,
    y2: 1873.95,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -363.75,
    y1: 1873.95,
    x2: -361.18,
    y2: 1873.95,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -356.92,
    y1: 1879.1,
    x2: -354.61,
    y2: 1879.1,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5c4fb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6b5ebc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9187d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9288d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -353.64,
    y1: 1879.1,
    x2: -351.32,
    y2: 1879.1,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -360.21,
    y1: 1879.1,
    x2: -357.9,
    y2: 1879.1,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#cd5e9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d86da3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f596b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa4bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -325.65,
    y1: 1879.1,
    x2: -319.9,
    y2: 1879.1,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -350.35,
    y1: 1879.1,
    x2: -326.62,
    y2: 1879.1,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -363.75,
    y1: 1879.1,
    x2: -361.18,
    y2: 1879.1,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -356.92,
    y1: 1884.26,
    x2: -354.61,
    y2: 1884.26,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#634ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7259bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9b82d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d84d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -353.64,
    y1: 1884.26,
    x2: -351.32,
    y2: 1884.26,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -360.21,
    y1: 1884.26,
    x2: -357.9,
    y2: 1884.26,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c8579e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d466a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f38fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9ebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -325.65,
    y1: 1884.25,
    x2: -319.9,
    y2: 1884.25,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -350.35,
    y1: 1884.26,
    x2: -326.62,
    y2: 1884.26,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -363.75,
    y1: 1884.26,
    x2: -361.18,
    y2: 1884.26,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -356.92,
    y1: 1889.41,
    x2: -354.61,
    y2: 1889.41,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6a44b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#7953b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a27acd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a880d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -353.64,
    y1: 1889.41,
    x2: -351.32,
    y2: 1889.41,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -360.21,
    y1: 1889.41,
    x2: -357.9,
    y2: 1889.41,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c4509f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#d15fa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f288b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff97c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -325.65,
    y1: 1889.41,
    x2: -319.9,
    y2: 1889.41,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -350.35,
    y1: 1889.41,
    x2: -326.62,
    y2: 1889.41,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -363.75,
    y1: 1889.41,
    x2: -361.18,
    y2: 1889.41,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -356.92,
    y1: 1894.56,
    x2: -354.61,
    y2: 1894.56,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#703fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7f4db8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a872cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b37dd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -353.64,
    y1: 1894.56,
    x2: -351.32,
    y2: 1894.56,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: -360.21,
    y1: 1894.56,
    x2: -357.9,
    y2: 1894.56,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#bf49a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#cd58a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f081ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff91c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -325.65,
    y1: 1894.56,
    x2: -319.9,
    y2: 1894.56,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -350.35,
    y1: 1894.56,
    x2: -326.62,
    y2: 1894.56,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -363.75,
    y1: 1894.56,
    x2: -361.18,
    y2: 1894.56,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: -356.92,
    y1: 1899.71,
    x2: -354.61,
    y2: 1899.71,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#773ab0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8648b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#af6bc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be79d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -353.64,
    y1: 1899.72,
    x2: -351.32,
    y2: 1899.72,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -360.21,
    y1: 1899.71,
    x2: -357.9,
    y2: 1899.71,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ba42a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c951a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ef7abb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8ac3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: -325.65,
    y1: 1899.71,
    x2: -319.9,
    y2: 1899.71,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: -350.35,
    y1: 1899.71,
    x2: -326.62,
    y2: 1899.71,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: -363.75,
    y1: 1899.71,
    x2: -361.18,
    y2: 1899.71,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -356.92,
    y1: 1904.87,
    x2: -354.61,
    y2: 1904.87,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7e34af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8d41b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#b664c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c975cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -353.64,
    y1: 1904.87,
    x2: -351.32,
    y2: 1904.87,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -360.21,
    y1: 1904.87,
    x2: -357.9,
    y2: 1904.87,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b63ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c54aab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ee73bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff84c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: -325.65,
    y1: 1904.87,
    x2: -319.9,
    y2: 1904.87,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -350.35,
    y1: 1904.87,
    x2: -326.62,
    y2: 1904.87,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -363.75,
    y1: 1904.87,
    x2: -361.18,
    y2: 1904.87,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -356.92,
    y1: 1910.02,
    x2: -354.61,
    y2: 1910.02,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#842fae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#933cb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#bc5ec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d472cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -353.64,
    y1: 1910.02,
    x2: -351.32,
    y2: 1910.02,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -360.21,
    y1: 1910.02,
    x2: -357.9,
    y2: 1910.02,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b134a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#c042ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e968bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7dc7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -325.65,
    y1: 1910.02,
    x2: -319.9,
    y2: 1910.02,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -350.35,
    y1: 1910.02,
    x2: -326.62,
    y2: 1910.02,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -363.75,
    y1: 1910.02,
    x2: -361.18,
    y2: 1910.02,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -356.92,
    y1: 1915.17,
    x2: -354.61,
    y2: 1915.17,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8b29ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a36b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#c357c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de6ecf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -353.64,
    y1: 1915.17,
    x2: -351.32,
    y2: 1915.17,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -360.21,
    y1: 1915.17,
    x2: -357.9,
    y2: 1915.17,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ad2ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#bc3cad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e55fbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff77c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -325.65,
    y1: 1915.17,
    x2: -319.9,
    y2: 1915.17,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -350.35,
    y1: 1915.17,
    x2: -326.62,
    y2: 1915.17,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: -363.75,
    y1: 1915.17,
    x2: -361.18,
    y2: 1915.17,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -356.92,
    y1: 1920.33,
    x2: -354.61,
    y2: 1920.33,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9224ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#a130b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ca51c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e96acf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -353.64,
    y1: 1920.33,
    x2: -351.32,
    y2: 1920.33,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -360.21,
    y1: 1920.33,
    x2: -357.9,
    y2: 1920.33,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#a827a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b734ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e056be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -325.65,
    y1: 1920.33,
    x2: -319.9,
    y2: 1920.33,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -350.35,
    y1: 1920.33,
    x2: -326.62,
    y2: 1920.33,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: -363.75,
    y1: 1920.33,
    x2: -361.18,
    y2: 1920.33,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: -356.92,
    y1: 1925.48,
    x2: -354.61,
    y2: 1925.48,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#981eac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#a72ab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d04ac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f467ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -353.64,
    y1: 1925.48,
    x2: -351.32,
    y2: 1925.48,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: -360.21,
    y1: 1925.48,
    x2: -357.9,
    y2: 1925.48,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#a420aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#b32db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#dc4dbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6acc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: -325.65,
    y1: 1925.48,
    x2: -319.9,
    y2: 1925.48,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: -350.35,
    y1: 1925.48,
    x2: -326.62,
    y2: 1925.48,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: -363.75,
    y1: 1925.48,
    x2: -361.18,
    y2: 1925.48,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9",
    x1: -356.92,
    y1: 1930.63,
    x2: -354.61,
    y2: 1930.63,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 322.67, -1856.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d744bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-2",
    x1: -353.64,
    y1: 1930.63,
    x2: -351.32,
    y2: 1930.63,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-3",
    x1: -360.21,
    y1: 1930.63,
    x2: -357.9,
    y2: 1930.63,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-4",
    x1: -325.65,
    y1: 1930.63,
    x2: -319.9,
    y2: 1930.63,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-5",
    x1: -350.35,
    y1: 1930.63,
    x2: -326.62,
    y2: 1930.63,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-6",
    x1: -363.75,
    y1: 1930.63,
    x2: -361.18,
    y2: 1930.63,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7",
    x1: 4.58,
    y1: 137.94,
    x2: 43.48,
    y2: 137.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1fc3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-12",
    x1: -90.19,
    y1: 163.55,
    x2: 143.32,
    y2: 111.21,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 49.08,
    y1: 211.88,
    x2: 5.33,
    y2: 82.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#364f87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#263860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#19243d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0e1422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#06090f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 20.36,
    y1: 51.96,
    x2: 26.16,
    y2: 109.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8a266a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0f040c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-13",
    x1: 142.96,
    y1: 234.71,
    x2: 323.03,
    y2: 180.79,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-14",
    x1: 24.84,
    y1: 255.98,
    x2: 158.97,
    y2: 225.91,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-15",
    x1: 142.96,
    y1: 244.06,
    x2: 323.03,
    y2: 190.14,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-16",
    x1: 24.84,
    y1: 265.33,
    x2: 158.97,
    y2: 235.27,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-17",
    x1: 219.12,
    y1: 48.52,
    x2: 126.47,
    y2: 225.1,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-18",
    x1: 89.95,
    y1: 127.98,
    x2: 344.99,
    y2: 51.61,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-19",
    x1: 134.83,
    y1: 157.44,
    x2: 362.71,
    y2: 89.21,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-20",
    x1: -9.05,
    y1: 184.66,
    x2: 199.59,
    y2: 137.89,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-21",
    x1: 207.97,
    y1: -73.94,
    x2: 125.19,
    y2: 83.83,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-22",
    x1: 137.26,
    y1: 155.57,
    x2: 392.3,
    y2: 79.21,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-23",
    x1: 219.12,
    y1: -103.39,
    x2: 126.47,
    y2: 73.19,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: -280.23,
    y1: 1808.69,
    x2: -277.91,
    y2: 1808.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: -276.94,
    y1: 1808.69,
    x2: -274.63,
    y2: 1808.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-2",
    x1: -283.51,
    y1: 1808.69,
    x2: -281.2,
    y2: 1808.69,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: -248.95,
    y1: 1808.69,
    x2: -243.2,
    y2: 1808.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -273.65,
    y1: 1808.69,
    x2: -249.93,
    y2: 1808.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -287.06,
    y1: 1808.69,
    x2: -284.49,
    y2: 1808.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -280.23,
    y1: 1813.84,
    x2: -277.91,
    y2: 1813.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -276.94,
    y1: 1813.84,
    x2: -274.63,
    y2: 1813.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -283.51,
    y1: 1813.84,
    x2: -281.2,
    y2: 1813.84,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -248.95,
    y1: 1813.84,
    x2: -243.2,
    y2: 1813.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -273.65,
    y1: 1813.84,
    x2: -249.93,
    y2: 1813.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -287.06,
    y1: 1813.84,
    x2: -284.49,
    y2: 1813.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -280.23,
    y1: 1818.99,
    x2: -277.91,
    y2: 1818.99,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -276.94,
    y1: 1818.99,
    x2: -274.63,
    y2: 1818.99,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -283.51,
    y1: 1818.99,
    x2: -281.2,
    y2: 1818.99,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: -248.95,
    y1: 1818.99,
    x2: -243.2,
    y2: 1818.99,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: -273.65,
    y1: 1818.99,
    x2: -249.93,
    y2: 1818.99,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: -287.06,
    y1: 1818.99,
    x2: -284.49,
    y2: 1818.99,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: -280.23,
    y1: 1824.15,
    x2: -277.91,
    y2: 1824.15,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -276.94,
    y1: 1824.15,
    x2: -274.63,
    y2: 1824.15,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: -283.51,
    y1: 1824.15,
    x2: -281.2,
    y2: 1824.15,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: -248.95,
    y1: 1824.14,
    x2: -243.2,
    y2: 1824.14,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -273.65,
    y1: 1824.14,
    x2: -249.93,
    y2: 1824.14,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: -287.06,
    y1: 1824.15,
    x2: -284.49,
    y2: 1824.15,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: -280.23,
    y1: 1829.3,
    x2: -277.91,
    y2: 1829.3,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: -276.94,
    y1: 1829.3,
    x2: -274.63,
    y2: 1829.3,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: -283.51,
    y1: 1829.3,
    x2: -281.2,
    y2: 1829.3,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -248.95,
    y1: 1829.3,
    x2: -243.2,
    y2: 1829.3,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -273.65,
    y1: 1829.3,
    x2: -249.93,
    y2: 1829.3,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: -287.06,
    y1: 1829.3,
    x2: -284.49,
    y2: 1829.3,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: -280.23,
    y1: 1834.45,
    x2: -277.91,
    y2: 1834.45,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: -276.94,
    y1: 1834.45,
    x2: -274.63,
    y2: 1834.45,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: -283.51,
    y1: 1834.45,
    x2: -281.2,
    y2: 1834.45,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: -248.95,
    y1: 1834.45,
    x2: -243.2,
    y2: 1834.45,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: -273.65,
    y1: 1834.45,
    x2: -249.93,
    y2: 1834.45,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: -287.06,
    y1: 1834.45,
    x2: -284.49,
    y2: 1834.45,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: -280.23,
    y1: 1839.6,
    x2: -277.91,
    y2: 1839.6,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: -276.94,
    y1: 1839.6,
    x2: -274.63,
    y2: 1839.6,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: -283.51,
    y1: 1839.6,
    x2: -281.2,
    y2: 1839.6,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: -248.95,
    y1: 1839.6,
    x2: -243.2,
    y2: 1839.6,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: -273.65,
    y1: 1839.6,
    x2: -249.93,
    y2: 1839.6,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: -287.06,
    y1: 1839.6,
    x2: -284.49,
    y2: 1839.6,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: -280.23,
    y1: 1844.76,
    x2: -277.91,
    y2: 1844.76,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: -276.94,
    y1: 1844.76,
    x2: -274.63,
    y2: 1844.76,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: -283.51,
    y1: 1844.76,
    x2: -281.2,
    y2: 1844.76,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: -248.95,
    y1: 1844.76,
    x2: -243.2,
    y2: 1844.76,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: -273.65,
    y1: 1844.76,
    x2: -249.93,
    y2: 1844.76,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: -287.06,
    y1: 1844.76,
    x2: -284.49,
    y2: 1844.76,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: -280.23,
    y1: 1849.91,
    x2: -277.91,
    y2: 1849.91,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: -276.94,
    y1: 1849.91,
    x2: -274.63,
    y2: 1849.91,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: -283.51,
    y1: 1849.91,
    x2: -281.2,
    y2: 1849.91,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: -248.95,
    y1: 1849.91,
    x2: -243.2,
    y2: 1849.91,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: -273.65,
    y1: 1849.91,
    x2: -249.93,
    y2: 1849.91,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: -287.06,
    y1: 1849.91,
    x2: -284.49,
    y2: 1849.91,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: -280.23,
    y1: 1855.06,
    x2: -277.91,
    y2: 1855.06,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: -276.94,
    y1: 1855.06,
    x2: -274.63,
    y2: 1855.06,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: -283.51,
    y1: 1855.06,
    x2: -281.2,
    y2: 1855.06,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: -248.95,
    y1: 1855.06,
    x2: -243.2,
    y2: 1855.06,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: -273.65,
    y1: 1855.06,
    x2: -249.93,
    y2: 1855.06,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: -287.06,
    y1: 1855.06,
    x2: -284.49,
    y2: 1855.06,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: -280.23,
    y1: 1860.22,
    x2: -277.91,
    y2: 1860.22,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: -276.94,
    y1: 1860.22,
    x2: -274.63,
    y2: 1860.22,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: -283.51,
    y1: 1860.22,
    x2: -281.2,
    y2: 1860.22,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: -248.95,
    y1: 1860.22,
    x2: -243.2,
    y2: 1860.22,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: -273.65,
    y1: 1860.22,
    x2: -249.93,
    y2: 1860.22,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: -287.06,
    y1: 1860.22,
    x2: -284.49,
    y2: 1860.22,
    xlinkHref: "#linear-gradient-60"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: -280.23,
    y1: 1865.37,
    x2: -277.91,
    y2: 1865.37,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: -276.94,
    y1: 1865.37,
    x2: -274.63,
    y2: 1865.37,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: -283.51,
    y1: 1865.37,
    x2: -281.2,
    y2: 1865.37,
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: -248.95,
    y1: 1865.37,
    x2: -243.2,
    y2: 1865.37,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: -273.65,
    y1: 1865.37,
    x2: -249.93,
    y2: 1865.37,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: -287.06,
    y1: 1865.37,
    x2: -284.49,
    y2: 1865.37,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: -280.23,
    y1: 1870.52,
    x2: -277.91,
    y2: 1870.52,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: -276.94,
    y1: 1870.52,
    x2: -274.63,
    y2: 1870.52,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: -283.51,
    y1: 1870.52,
    x2: -281.2,
    y2: 1870.52,
    xlinkHref: "#linear-gradient-74"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: -248.95,
    y1: 1870.52,
    x2: -243.2,
    y2: 1870.52,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: -273.65,
    y1: 1870.52,
    x2: -249.93,
    y2: 1870.52,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: -287.06,
    y1: 1870.52,
    x2: -284.49,
    y2: 1870.52,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: -280.23,
    y1: 1875.68,
    x2: -277.91,
    y2: 1875.68,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: -276.94,
    y1: 1875.68,
    x2: -274.63,
    y2: 1875.68,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: -283.51,
    y1: 1875.68,
    x2: -281.2,
    y2: 1875.68,
    xlinkHref: "#linear-gradient-80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: -248.95,
    y1: 1875.68,
    x2: -243.2,
    y2: 1875.68,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: -273.65,
    y1: 1875.68,
    x2: -249.93,
    y2: 1875.68,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: -287.06,
    y1: 1875.68,
    x2: -284.49,
    y2: 1875.68,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: -280.23,
    y1: 1880.83,
    x2: -277.91,
    y2: 1880.83,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: -276.94,
    y1: 1880.83,
    x2: -274.63,
    y2: 1880.83,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: -283.51,
    y1: 1880.83,
    x2: -281.2,
    y2: 1880.83,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: -248.95,
    y1: 1880.83,
    x2: -243.2,
    y2: 1880.83,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: -273.65,
    y1: 1880.83,
    x2: -249.93,
    y2: 1880.83,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: -287.06,
    y1: 1880.83,
    x2: -284.49,
    y2: 1880.83,
    xlinkHref: "#linear-gradient-84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: -280.23,
    y1: 1885.98,
    x2: -277.91,
    y2: 1885.98,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: -276.94,
    y1: 1885.98,
    x2: -274.63,
    y2: 1885.98,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: -283.51,
    y1: 1885.98,
    x2: -281.2,
    y2: 1885.98,
    xlinkHref: "#linear-gradient-92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: -248.95,
    y1: 1885.98,
    x2: -243.2,
    y2: 1885.98,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: -273.65,
    y1: 1885.98,
    x2: -249.93,
    y2: 1885.98,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: -287.06,
    y1: 1885.98,
    x2: -284.49,
    y2: 1885.98,
    xlinkHref: "#linear-gradient-90"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: -280.23,
    y1: 1891.14,
    x2: -277.91,
    y2: 1891.14,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: -276.94,
    y1: 1891.14,
    x2: -274.63,
    y2: 1891.14,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: -283.51,
    y1: 1891.14,
    x2: -281.2,
    y2: 1891.14,
    xlinkHref: "#linear-gradient-98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: -248.95,
    y1: 1891.13,
    x2: -243.2,
    y2: 1891.13,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: -273.65,
    y1: 1891.13,
    x2: -249.93,
    y2: 1891.13,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: -287.06,
    y1: 1891.13,
    x2: -284.49,
    y2: 1891.13,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: -280.23,
    y1: 1896.29,
    x2: -277.91,
    y2: 1896.29,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: -276.94,
    y1: 1896.29,
    x2: -274.63,
    y2: 1896.29,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: -283.51,
    y1: 1896.29,
    x2: -281.2,
    y2: 1896.29,
    xlinkHref: "#linear-gradient-104"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: -248.95,
    y1: 1896.29,
    x2: -243.2,
    y2: 1896.29,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: -273.65,
    y1: 1896.29,
    x2: -249.93,
    y2: 1896.29,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: -287.06,
    y1: 1896.29,
    x2: -284.49,
    y2: 1896.29,
    xlinkHref: "#linear-gradient-102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: -280.23,
    y1: 1901.44,
    x2: -277.91,
    y2: 1901.44,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: -276.94,
    y1: 1901.44,
    x2: -274.63,
    y2: 1901.44,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: -283.51,
    y1: 1901.44,
    x2: -281.2,
    y2: 1901.44,
    xlinkHref: "#linear-gradient-110"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: -248.95,
    y1: 1901.44,
    x2: -243.2,
    y2: 1901.44,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: -273.65,
    y1: 1901.44,
    x2: -249.93,
    y2: 1901.44,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: -287.06,
    y1: 1901.44,
    x2: -284.49,
    y2: 1901.44,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: -280.23,
    y1: 1906.59,
    x2: -277.91,
    y2: 1906.59,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: -276.94,
    y1: 1906.59,
    x2: -274.63,
    y2: 1906.59,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: -283.51,
    y1: 1906.59,
    x2: -281.2,
    y2: 1906.59,
    xlinkHref: "#linear-gradient-116"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: -248.95,
    y1: 1906.59,
    x2: -243.2,
    y2: 1906.59,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: -273.65,
    y1: 1906.59,
    x2: -249.93,
    y2: 1906.59,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: -287.06,
    y1: 1906.59,
    x2: -284.49,
    y2: 1906.59,
    xlinkHref: "#linear-gradient-114"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: -280.23,
    y1: 1911.75,
    x2: -277.91,
    y2: 1911.75,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: -276.94,
    y1: 1911.75,
    x2: -274.63,
    y2: 1911.75,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: -283.51,
    y1: 1911.75,
    x2: -281.2,
    y2: 1911.75,
    xlinkHref: "#linear-gradient-122"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: -248.95,
    y1: 1911.75,
    x2: -243.2,
    y2: 1911.75,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: -273.65,
    y1: 1911.75,
    x2: -249.93,
    y2: 1911.75,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: -287.06,
    y1: 1911.75,
    x2: -284.49,
    y2: 1911.75,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-7",
    x1: -280.23,
    y1: 1916.9,
    x2: -277.91,
    y2: 1916.9,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-8",
    x1: -276.94,
    y1: 1916.9,
    x2: -274.63,
    y2: 1916.9,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-9",
    x1: -283.51,
    y1: 1916.9,
    x2: -281.2,
    y2: 1916.9,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-10",
    x1: -248.95,
    y1: 1916.9,
    x2: -243.2,
    y2: 1916.9,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-11",
    x1: -273.65,
    y1: 1916.9,
    x2: -249.93,
    y2: 1916.9,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-12",
    x1: -287.06,
    y1: 1916.9,
    x2: -284.49,
    y2: 1916.9,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-2",
    x1: 70.99,
    y1: 160.44,
    x2: 109.9,
    y2: 160.44,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_25-24",
    x1: -23.77,
    y1: 186.04,
    x2: 209.74,
    y2: 133.7,
    xlinkHref: "#New_Gradient_Swatch_copy_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 115.39,
    y1: 234.04,
    x2: 65.01,
    y2: 85.33,
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 85.56,
    y1: 62.37,
    x2: 91.36,
    y2: 119.83,
    xlinkHref: "#linear-gradient-127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-13",
    x1: -91.18,
    y1: 167.93,
    x2: 211.97,
    y2: 99.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: -72.6,
    y1: 161.69,
    x2: 188.39,
    y2: 103.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#b5b4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#cbcad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e7e7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f9f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-14",
    x1: 125.57,
    y1: 138.81,
    x2: 336.28,
    y2: 75.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 126.76,
    y1: 137.84,
    x2: 334.15,
    y2: 75.74,
    xlinkHref: "#linear-gradient-255"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-15",
    x1: -108.1,
    y1: 419.18,
    x2: 229.69,
    y2: 343.46,
    gradientTransform: "matrix(1, 0.11, 0, 1, 0, -276.03)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: -108.1,
    y1: 419.18,
    x2: 229.69,
    y2: 343.46,
    gradientTransform: "matrix(1, 0.11, 0, 1, 0, -276.03)",
    xlinkHref: "#linear-gradient-255"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-16",
    x1: 134.26,
    y1: 150.41,
    x2: 287.44,
    y2: 104.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 134.26,
    y1: 150.39,
    x2: 287.43,
    y2: 104.53,
    xlinkHref: "#linear-gradient-255"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 86.62,
    y1: 267.68,
    x2: 12.76,
    y2: 267.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#a31cac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#c234b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#dc48c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ed55c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#e04bc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dc48c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-17",
    x1: 92.69,
    y1: 174.08,
    x2: 43.91,
    y2: 267.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    cx: 46.23,
    cy: 266.17,
    r: 20.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 86.62,
    y1: 271.87,
    x2: 12.76,
    y2: 271.87,
    xlinkHref: "#linear-gradient-259"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 33.07,
    y1: 229.44,
    x2: 70.94,
    y2: 237.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1a1d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#c8abda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#dac6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f7f2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f9f5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e8dbef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d5bfe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c7afe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b397de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a788dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a383db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ae8ddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8a6de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-18",
    x1: 33.92,
    y1: 192.45,
    x2: 55.22,
    y2: 203.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 29.62,
    y1: 248.4,
    x2: 66.91,
    y2: 256.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c211a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#c518a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ce2daf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#cf30b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#eb48bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c211a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#a919ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ac18aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b715a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c211a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 34.08,
    y1: 227.2,
    x2: 71.36,
    y2: 235.03,
    xlinkHref: "#linear-gradient-262"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 38.57,
    y1: 205.81,
    x2: 75.86,
    y2: 213.65,
    xlinkHref: "#linear-gradient-262"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_18",
    x1: 55.83,
    y1: 200.32,
    x2: 42.89,
    y2: 200.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d744bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dc48c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Linear_Gradient_1",
    x1: 50.13,
    y1: 198.01,
    x2: 50.13,
    y2: 220.12,
    xlinkHref: "#Radial_Gradient_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -2866.36,
    cy: -208.37,
    r: 21.24,
    gradientTransform: "matrix(0.32, -0.06, 0.19, 0.98, 1026.38, 257.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0d043d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#070222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#03010f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy_6",
    cx: 13494.53,
    cy: 829.7,
    r: 21.24,
    gradientTransform: "matrix(-0.32, -0.06, -0.19, 0.98, 4562.38, 257.38)",
    xlinkHref: "#linear-gradient-127"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47.67 228.42 47.67 236.72 132.79 187.82 132.79 179.51 47.67 228.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47.7 228.42 47.7 236.72 0.36 209.12 0.36 200.85 47.7 228.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "47.67 237.77 47.67 246.07 132.79 197.17 132.79 188.86 47.67 237.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "47.7 237.77 47.7 246.07 0.36 218.47 0.36 210.2 47.7 237.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0.36 200.85 47.7 228.42 132.79 179.51 85.4 151.91 0.36 200.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "0.36 48.91 0.36 199.36 85.47 150.46 85.47 0 0.36 48.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "47.71 84.39 47.71 218.83 123.76 175.13 123.76 40.7 47.71 84.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "47.73 84.39 47.73 218.83 5.44 194.17 5.44 59.76 47.73 84.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "5.44 59.76 47.73 84.39 123.76 40.7 81.42 16.04 5.44 59.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "47.67 76.5 47.67 226.96 132.79 178.06 132.79 27.6 47.67 76.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "0.36 48.94 47.7 76.5 132.79 27.6 85.4 0 0.36 48.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "15.58 69.43 13.58 68.27 13.58 70.72 15.58 71.88 15.58 69.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "18.42 71.07 16.42 69.92 16.42 72.36 18.42 73.52 18.42 71.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "10.73 69.08 12.73 70.23 12.73 67.78 10.73 66.63 10.73 69.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "40.66 83.91 40.66 86.36 45.64 89.23 45.64 86.78 40.66 83.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "39.81 83.42 19.27 71.56 19.27 74.01 39.81 85.87 39.81 83.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "9.88 66.14 7.66 64.86 7.66 67.31 9.88 68.59 9.88 66.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "15.58 75.38 13.58 74.22 13.58 76.67 15.58 77.83 15.58 75.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "18.42 77.02 16.42 75.86 16.42 78.31 18.42 79.47 18.42 77.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "10.73 75.03 12.73 76.18 12.73 73.73 10.73 72.58 10.73 75.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "40.66 89.86 40.66 92.31 45.64 95.18 45.64 92.73 40.66 89.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "39.81 89.37 19.27 77.51 19.27 79.96 39.81 91.82 39.81 89.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "9.88 72.09 7.66 70.81 7.66 73.26 9.88 74.54 9.88 72.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "15.58 81.33 13.58 80.17 13.58 82.62 15.58 83.78 15.58 81.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "18.42 82.97 16.42 81.81 16.42 84.27 18.42 85.42 18.42 82.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "10.73 80.98 12.73 82.13 12.73 79.69 10.73 78.53 10.73 80.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "40.66 95.81 40.66 98.26 45.64 101.13 45.64 98.69 40.66 95.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "39.81 95.32 19.27 83.46 19.27 85.91 39.81 97.77 39.81 95.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "9.88 78.04 7.66 76.76 7.66 79.21 9.88 80.49 9.88 78.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "15.58 87.28 13.58 86.12 13.58 88.57 15.58 89.73 15.58 87.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "18.42 88.92 16.42 87.77 16.42 90.22 18.42 91.37 18.42 88.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "10.73 86.93 12.73 88.08 12.73 85.64 10.73 84.48 10.73 86.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "40.66 101.76 40.66 104.21 45.64 107.08 45.64 104.64 40.66 101.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "39.81 101.27 19.27 89.41 19.27 91.86 39.81 103.72 39.81 101.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "9.88 83.99 7.66 82.71 7.66 85.16 9.88 86.44 9.88 83.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "15.58 93.23 13.58 92.07 13.58 94.52 15.58 95.68 15.58 93.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "18.42 94.87 16.42 93.72 16.42 96.17 18.42 97.32 18.42 94.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "10.73 92.88 12.73 94.03 12.73 91.58 10.73 90.43 10.73 92.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "40.66 107.71 40.66 110.16 45.64 113.03 45.64 110.59 40.66 107.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "39.81 107.22 19.27 95.36 19.27 97.81 39.81 109.67 39.81 107.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "9.88 89.94 7.66 88.66 7.66 91.11 9.88 92.39 9.88 89.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "15.58 99.18 13.58 98.02 13.58 100.47 15.58 101.63 15.58 99.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "18.42 100.82 16.42 99.67 16.42 102.12 18.42 103.27 18.42 100.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "10.73 98.83 12.73 99.98 12.73 97.53 10.73 96.38 10.73 98.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "40.66 113.66 40.66 116.11 45.64 118.98 45.64 116.54 40.66 113.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "39.81 113.17 19.27 101.31 19.27 103.76 39.81 115.62 39.81 113.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "9.88 95.89 7.66 94.61 7.66 97.06 9.88 98.34 9.88 95.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "15.58 105.13 13.58 103.97 13.58 106.42 15.58 107.58 15.58 105.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "18.42 106.77 16.42 105.62 16.42 108.07 18.42 109.22 18.42 106.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "10.73 104.78 12.73 105.94 12.73 103.48 10.73 102.33 10.73 104.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "40.66 119.61 40.66 122.06 45.64 124.94 45.64 122.49 40.66 119.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "39.81 119.12 19.27 107.26 19.27 109.71 39.81 121.57 39.81 119.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "9.88 101.84 7.66 100.56 7.66 103.01 9.88 104.29 9.88 101.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "15.58 111.08 13.58 109.92 13.58 112.37 15.58 113.53 15.58 111.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "18.42 112.72 16.42 111.57 16.42 114.02 18.42 115.17 18.42 112.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "10.73 110.73 12.73 111.89 12.73 109.44 10.73 108.28 10.73 110.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "40.66 125.56 40.66 128.01 45.64 130.89 45.64 128.44 40.66 125.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "39.81 125.07 19.27 113.21 19.27 115.66 39.81 127.52 39.81 125.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "9.88 107.79 7.66 106.51 7.66 108.96 9.88 110.24 9.88 107.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "15.58 117.03 13.58 115.87 13.58 118.32 15.58 119.48 15.58 117.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "18.42 118.67 16.42 117.52 16.42 119.97 18.42 121.12 18.42 118.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "10.73 116.68 12.73 117.83 12.73 115.39 10.73 114.23 10.73 116.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "40.66 131.51 40.66 133.96 45.64 136.84 45.64 134.39 40.66 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "39.81 131.02 19.27 119.16 19.27 121.61 39.81 133.47 39.81 131.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "9.88 113.74 7.66 112.46 7.66 114.91 9.88 116.19 9.88 113.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "15.58 122.98 13.58 121.82 13.58 124.27 15.58 125.43 15.58 122.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "18.42 124.62 16.42 123.47 16.42 125.92 18.42 127.07 18.42 124.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "10.73 122.63 12.73 123.78 12.73 121.34 10.73 120.18 10.73 122.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "40.66 137.46 40.66 139.91 45.64 142.79 45.64 140.34 40.66 137.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "39.81 136.97 19.27 125.11 19.27 127.56 39.81 139.42 39.81 136.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "9.88 119.69 7.66 118.41 7.66 120.86 9.88 122.14 9.88 119.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "15.58 128.93 13.58 127.77 13.58 130.22 15.58 131.38 15.58 128.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "18.42 130.57 16.42 129.42 16.42 131.87 18.42 133.02 18.42 130.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "10.73 128.58 12.73 129.74 12.73 127.29 10.73 126.13 10.73 128.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "40.66 143.41 40.66 145.86 45.64 148.74 45.64 146.29 40.66 143.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "39.81 142.92 19.27 131.06 19.27 133.51 39.81 145.37 39.81 142.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "9.88 125.64 7.66 124.36 7.66 126.81 9.88 128.09 9.88 125.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "15.58 134.88 13.58 133.72 13.58 136.17 15.58 137.33 15.58 134.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "18.42 136.52 16.42 135.37 16.42 137.82 18.42 138.97 18.42 136.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "10.73 134.53 12.73 135.69 12.73 133.24 10.73 132.08 10.73 134.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "40.66 149.36 40.66 151.81 45.64 154.69 45.64 152.24 40.66 149.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "39.81 148.87 19.27 137.01 19.27 139.46 39.81 151.32 39.81 148.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "9.88 131.59 7.66 130.31 7.66 132.76 9.88 134.04 9.88 131.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "15.58 140.83 13.58 139.68 13.58 142.12 15.58 143.28 15.58 140.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "18.42 142.47 16.42 141.32 16.42 143.77 18.42 144.92 18.42 142.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "10.73 140.48 12.73 141.64 12.73 139.19 10.73 138.03 10.73 140.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "40.66 155.31 40.66 157.76 45.64 160.64 45.64 158.19 40.66 155.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "39.81 154.82 19.27 142.96 19.27 145.41 39.81 157.27 39.81 154.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "9.88 137.54 7.66 136.26 7.66 138.71 9.88 139.99 9.88 137.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "15.58 146.78 13.58 145.63 13.58 148.07 15.58 149.23 15.58 146.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "18.42 148.42 16.42 147.27 16.42 149.72 18.42 150.87 18.42 148.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "10.73 146.43 12.73 147.59 12.73 145.14 10.73 143.98 10.73 146.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "40.66 161.26 40.66 163.71 45.64 166.59 45.64 164.14 40.66 161.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "39.81 160.77 19.27 148.91 19.27 151.36 39.81 163.22 39.81 160.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "9.88 143.49 7.66 142.21 7.66 144.66 9.88 145.94 9.88 143.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "15.58 152.73 13.58 151.57 13.58 154.02 15.58 155.18 15.58 152.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "18.42 154.37 16.42 153.22 16.42 155.67 18.42 156.82 18.42 154.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "10.73 152.38 12.73 153.54 12.73 151.09 10.73 149.93 10.73 152.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "40.66 167.21 40.66 169.66 45.64 172.54 45.64 170.09 40.66 167.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "39.81 166.72 19.27 154.86 19.27 157.31 39.81 169.17 39.81 166.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "9.88 149.44 7.66 148.16 7.66 150.61 9.88 151.89 9.88 149.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "15.58 158.68 13.58 157.53 13.58 159.97 15.58 161.13 15.58 158.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "18.42 160.32 16.42 159.17 16.42 161.62 18.42 162.77 18.42 160.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "10.73 158.33 12.73 159.49 12.73 157.04 10.73 155.88 10.73 158.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "40.66 173.16 40.66 175.61 45.64 178.49 45.64 176.04 40.66 173.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "39.81 172.67 19.27 160.81 19.27 163.26 39.81 175.12 39.81 172.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "9.88 155.4 7.66 154.11 7.66 156.56 9.88 157.84 9.88 155.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "15.58 164.63 13.58 163.48 13.58 165.93 15.58 167.08 15.58 164.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "18.42 166.27 16.42 165.12 16.42 167.57 18.42 168.72 18.42 166.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "10.73 164.28 12.73 165.44 12.73 162.99 10.73 161.83 10.73 164.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "40.66 179.11 40.66 181.56 45.64 184.44 45.64 181.99 40.66 179.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "39.81 178.62 19.27 166.76 19.27 169.21 39.81 181.07 39.81 178.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "9.88 161.34 7.66 160.06 7.66 162.51 9.88 163.79 9.88 161.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "15.58 170.58 13.58 169.43 13.58 171.88 15.58 173.03 15.58 170.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "18.42 172.22 16.42 171.07 16.42 173.52 18.42 174.67 18.42 172.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "10.73 170.23 12.73 171.39 12.73 168.94 10.73 167.78 10.73 170.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "40.66 185.06 40.66 187.51 45.64 190.39 45.64 187.94 40.66 185.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "39.81 184.57 19.27 172.71 19.27 175.16 39.81 187.02 39.81 184.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "9.88 167.29 7.66 166.01 7.66 168.46 9.88 169.74 9.88 167.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "15.58 176.53 13.58 175.38 13.58 177.82 15.58 178.98 15.58 176.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "18.42 178.18 16.42 177.02 16.42 179.47 18.42 180.62 18.42 178.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "10.73 176.18 12.73 177.34 12.73 174.89 10.73 173.73 10.73 176.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "40.66 191.01 40.66 193.46 45.64 196.34 45.64 193.89 40.66 191.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "39.81 190.52 19.27 178.66 19.27 181.11 39.81 192.97 39.81 190.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "9.88 173.25 7.66 171.96 7.66 174.41 9.88 175.69 9.88 173.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "15.58 182.48 13.58 181.33 13.58 183.78 15.58 184.93 15.58 182.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "18.42 184.13 16.42 182.97 16.42 185.42 18.42 186.57 18.42 184.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "10.73 182.13 12.73 183.29 12.73 180.84 10.73 179.68 10.73 182.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "40.66 196.96 40.66 199.41 45.64 202.29 45.64 199.84 40.66 196.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "39.81 196.47 19.27 184.61 19.27 187.06 39.81 198.92 39.81 196.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "9.88 179.19 7.66 177.91 7.66 180.36 9.88 181.65 9.88 179.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "15.58 188.43 13.58 187.28 13.58 189.73 15.58 190.88 15.58 188.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "18.42 190.07 16.42 188.92 16.42 191.37 18.42 192.52 18.42 190.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "10.73 188.08 12.73 189.24 12.73 186.79 10.73 185.63 10.73 188.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "40.66 202.91 40.66 205.36 45.64 208.24 45.64 205.79 40.66 202.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "39.81 202.43 19.27 190.56 19.27 193.01 39.81 204.87 39.81 202.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "9.88 185.15 7.66 183.86 7.66 186.31 9.88 187.59 9.88 185.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "15.58 194.38 13.58 193.23 13.58 195.68 15.58 196.83 15.58 194.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "18.42 196.03 16.42 194.87 16.42 197.32 18.42 198.47 18.42 196.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "10.73 194.03 12.73 195.19 12.73 192.74 10.73 191.58 10.73 194.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "40.66 208.86 40.66 211.31 45.64 214.19 45.64 211.74 40.66 208.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "39.81 208.38 19.27 196.51 19.27 198.96 39.81 210.82 39.81 208.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "9.88 191.1 7.66 189.81 7.66 192.26 9.88 193.54 9.88 191.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "4.58 196.94 4.58 56.27 43.48 78.93 43.48 219.62 4.58 196.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M.36,48.94V199.36L47.7,227V76.5ZM43.48,219.62,4.58,196.94V56.27l38.9,22.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "0.36 48.94 0.36 199.36 47.7 226.96 47.7 76.5 0.36 48.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "0.36 48.94 0.36 100.07 47.7 127.67 47.7 76.5 0.36 48.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "114.09 250.91 114.09 259.21 199.21 210.31 199.21 202 114.09 250.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "114.12 250.91 114.12 259.21 66.78 231.62 66.78 223.34 114.12 250.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "114.09 260.26 114.09 268.56 199.21 219.66 199.21 211.35 114.09 260.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "114.12 260.26 114.12 268.56 66.78 240.97 66.78 232.69 114.12 260.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "66.78 223.34 114.12 250.91 199.21 202 151.81 174.4 66.78 223.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "66.78 71.4 66.78 221.85 151.89 172.95 151.89 22.49 66.78 71.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "114.13 106.89 114.13 241.32 190.18 197.62 190.18 63.19 114.13 106.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "114.15 106.89 114.15 241.32 71.85 216.66 71.85 82.25 114.15 106.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "71.85 82.25 114.15 106.89 190.18 63.19 147.83 38.53 71.85 82.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "114.09 98.99 114.09 249.45 199.21 200.54 199.21 50.09 114.09 98.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "66.78 71.43 114.12 98.99 199.21 50.09 151.81 22.49 66.78 71.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "82 91.92 79.99 90.76 79.99 93.21 82 94.37 82 91.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "84.84 93.56 82.84 92.41 82.84 94.86 84.84 96.01 84.84 93.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "77.15 91.57 79.15 92.72 79.15 90.28 77.15 89.12 77.15 91.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "107.08 106.4 107.08 108.85 112.06 111.72 112.06 109.28 107.08 106.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "106.23 105.91 85.69 94.05 85.69 96.5 106.23 108.36 106.23 105.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "76.31 88.63 74.08 87.35 74.08 89.8 76.31 91.08 76.31 88.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "82 97.87 79.99 96.71 79.99 99.16 82 100.32 82 97.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "84.84 99.51 82.84 98.36 82.84 100.81 84.84 101.96 84.84 99.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "77.15 97.52 79.15 98.67 79.15 96.22 77.15 95.07 77.15 97.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "107.08 112.35 107.08 114.8 112.06 117.67 112.06 115.23 107.08 112.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "106.23 111.86 85.69 100 85.69 102.45 106.23 114.31 106.23 111.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "76.31 94.58 74.08 93.3 74.08 95.75 76.31 97.03 76.31 94.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "82 103.82 79.99 102.66 79.99 105.11 82 106.27 82 103.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "84.84 105.46 82.84 104.31 82.84 106.76 84.84 107.91 84.84 105.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "77.15 103.47 79.15 104.63 79.15 102.17 77.15 101.02 77.15 103.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "107.08 118.3 107.08 120.75 112.06 123.63 112.06 121.18 107.08 118.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "106.23 117.81 85.69 105.95 85.69 108.4 106.23 120.26 106.23 117.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "76.31 100.53 74.08 99.25 74.08 101.7 76.31 102.98 76.31 100.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "82 109.77 79.99 108.61 79.99 111.06 82 112.22 82 109.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "84.84 111.41 82.84 110.26 82.84 112.71 84.84 113.86 84.84 111.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "77.15 109.42 79.15 110.58 79.15 108.13 77.15 106.97 77.15 109.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "107.08 124.25 107.08 126.7 112.06 129.58 112.06 127.13 107.08 124.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "106.23 123.76 85.69 111.9 85.69 114.35 106.23 126.21 106.23 123.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "76.31 106.48 74.08 105.2 74.08 107.65 76.31 108.93 76.31 106.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "82 115.72 79.99 114.56 79.99 117.01 82 118.17 82 115.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "84.84 117.36 82.84 116.21 82.84 118.66 84.84 119.81 84.84 117.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "77.15 115.37 79.15 116.53 79.15 114.08 77.15 112.92 77.15 115.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "107.08 130.2 107.08 132.65 112.06 135.53 112.06 133.08 107.08 130.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "106.23 129.71 85.69 117.85 85.69 120.3 106.23 132.16 106.23 129.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "76.31 112.43 74.08 111.15 74.08 113.6 76.31 114.88 76.31 112.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "82 121.67 79.99 120.51 79.99 122.96 82 124.12 82 121.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "84.84 123.31 82.84 122.16 82.84 124.61 84.84 125.76 84.84 123.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "77.15 121.32 79.15 122.48 79.15 120.03 77.15 118.87 77.15 121.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "107.08 136.15 107.08 138.6 112.06 141.48 112.06 139.03 107.08 136.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "106.23 135.66 85.69 123.8 85.69 126.25 106.23 138.11 106.23 135.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "76.31 118.38 74.08 117.1 74.08 119.55 76.31 120.83 76.31 118.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "82 127.62 79.99 126.46 79.99 128.91 82 130.07 82 127.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "84.84 129.26 82.84 128.11 82.84 130.56 84.84 131.71 84.84 129.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "77.15 127.27 79.15 128.43 79.15 125.98 77.15 124.82 77.15 127.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "107.08 142.1 107.08 144.55 112.06 147.43 112.06 144.98 107.08 142.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "106.23 141.61 85.69 129.75 85.69 132.2 106.23 144.06 106.23 141.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "76.31 124.33 74.08 123.05 74.08 125.5 76.31 126.78 76.31 124.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "82 133.57 79.99 132.41 79.99 134.86 82 136.02 82 133.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "84.84 135.21 82.84 134.06 82.84 136.51 84.84 137.66 84.84 135.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "77.15 133.22 79.15 134.38 79.15 131.93 77.15 130.77 77.15 133.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "107.08 148.05 107.08 150.5 112.06 153.38 112.06 150.93 107.08 148.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "106.23 147.56 85.69 135.7 85.69 138.15 106.23 150.01 106.23 147.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "76.31 130.28 74.08 129 74.08 131.45 76.31 132.73 76.31 130.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "82 139.52 79.99 138.36 79.99 140.81 82 141.97 82 139.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "84.84 141.16 82.84 140.01 82.84 142.46 84.84 143.61 84.84 141.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "77.15 139.17 79.15 140.33 79.15 137.88 77.15 136.72 77.15 139.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "107.08 154 107.08 156.45 112.06 159.33 112.06 156.88 107.08 154"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "106.23 153.51 85.69 141.65 85.69 144.1 106.23 155.96 106.23 153.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "76.31 136.23 74.08 134.95 74.08 137.4 76.31 138.68 76.31 136.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "82 145.47 79.99 144.31 79.99 146.76 82 147.92 82 145.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "84.84 147.11 82.84 145.96 82.84 148.41 84.84 149.56 84.84 147.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "77.15 145.12 79.15 146.28 79.15 143.83 77.15 142.67 77.15 145.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "107.08 159.95 107.08 162.4 112.06 165.28 112.06 162.83 107.08 159.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "106.23 159.46 85.69 147.6 85.69 150.05 106.23 161.91 106.23 159.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "76.31 142.18 74.08 140.9 74.08 143.35 76.31 144.63 76.31 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "82 151.42 79.99 150.26 79.99 152.72 82 153.87 82 151.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "84.84 153.06 82.84 151.91 82.84 154.36 84.84 155.51 84.84 153.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "77.15 151.07 79.15 152.23 79.15 149.78 77.15 148.62 77.15 151.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "107.08 165.9 107.08 168.35 112.06 171.23 112.06 168.78 107.08 165.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "106.23 165.41 85.69 153.55 85.69 156 106.23 167.86 106.23 165.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "76.31 148.13 74.08 146.85 74.08 149.3 76.31 150.58 76.31 148.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "82 157.37 79.99 156.22 79.99 158.66 82 159.82 82 157.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "84.84 159.01 82.84 157.86 82.84 160.31 84.84 161.46 84.84 159.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "77.15 157.02 79.15 158.18 79.15 155.73 77.15 154.57 77.15 157.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "107.08 171.85 107.08 174.3 112.06 177.18 112.06 174.73 107.08 171.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "106.23 171.36 85.69 159.5 85.69 161.95 106.23 173.81 106.23 171.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "76.31 154.08 74.08 152.8 74.08 155.25 76.31 156.53 76.31 154.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "82 163.32 79.99 162.16 79.99 164.62 82 165.77 82 163.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "84.84 164.96 82.84 163.81 82.84 166.26 84.84 167.41 84.84 164.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "77.15 162.97 79.15 164.13 79.15 161.68 77.15 160.52 77.15 162.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "107.08 177.8 107.08 180.25 112.06 183.13 112.06 180.68 107.08 177.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "106.23 177.31 85.69 165.45 85.69 167.9 106.23 179.76 106.23 177.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "76.31 160.03 74.08 158.75 74.08 161.2 76.31 162.48 76.31 160.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "82 169.27 79.99 168.12 79.99 170.56 82 171.72 82 169.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "84.84 170.91 82.84 169.76 82.84 172.21 84.84 173.36 84.84 170.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "77.15 168.92 79.15 170.08 79.15 167.63 77.15 166.47 77.15 168.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "107.08 183.75 107.08 186.2 112.06 189.08 112.06 186.63 107.08 183.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "106.23 183.26 85.69 171.4 85.69 173.85 106.23 185.72 106.23 183.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "76.31 165.98 74.08 164.7 74.08 167.15 76.31 168.43 76.31 165.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "82 175.22 79.99 174.06 79.99 176.52 82 177.67 82 175.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "84.84 176.86 82.84 175.71 82.84 178.16 84.84 179.31 84.84 176.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "77.15 174.87 79.15 176.03 79.15 173.58 77.15 172.42 77.15 174.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "107.08 189.7 107.08 192.15 112.06 195.03 112.06 192.58 107.08 189.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "106.23 189.22 85.69 177.35 85.69 179.8 106.23 191.66 106.23 189.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "76.31 171.94 74.08 170.65 74.08 173.1 76.31 174.38 76.31 171.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "82 181.17 79.99 180.02 79.99 182.47 82 183.62 82 181.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "84.84 182.81 82.84 181.66 82.84 184.11 84.84 185.27 84.84 182.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "77.15 180.82 79.15 181.98 79.15 179.53 77.15 178.37 77.15 180.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "107.08 195.65 107.08 198.1 112.06 200.98 112.06 198.53 107.08 195.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "106.23 195.17 85.69 183.3 85.69 185.75 106.23 197.62 106.23 195.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "76.31 177.88 74.08 176.6 74.08 179.05 76.31 180.33 76.31 177.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "82 187.12 79.99 185.97 79.99 188.42 82 189.57 82 187.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "84.84 188.76 82.84 187.61 82.84 190.06 84.84 191.22 84.84 188.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "77.15 186.77 79.15 187.93 79.15 185.48 77.15 184.32 77.15 186.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "107.08 201.6 107.08 204.05 112.06 206.93 112.06 204.48 107.08 201.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "106.23 201.12 85.69 189.25 85.69 191.7 106.23 203.56 106.23 201.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "76.31 183.84 74.08 182.55 74.08 185 76.31 186.28 76.31 183.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "82 193.07 79.99 191.92 79.99 194.37 82 195.52 82 193.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "84.84 194.72 82.84 193.56 82.84 196.01 84.84 197.17 84.84 194.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "77.15 192.72 79.15 193.88 79.15 191.43 77.15 190.27 77.15 192.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "107.08 207.55 107.08 210 112.06 212.88 112.06 210.43 107.08 207.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "106.23 207.07 85.69 195.2 85.69 197.65 106.23 209.52 106.23 207.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "76.31 189.78 74.08 188.5 74.08 190.95 76.31 192.23 76.31 189.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "82 199.02 79.99 197.87 79.99 200.32 82 201.47 82 199.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "84.84 200.66 82.84 199.51 82.84 201.96 84.84 203.12 84.84 200.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "77.15 198.67 79.15 199.83 79.15 197.38 77.15 196.22 77.15 198.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "107.08 213.5 107.08 215.95 112.06 218.83 112.06 216.38 107.08 213.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-272",
    points: "106.23 213.02 85.69 201.15 85.69 203.6 106.23 215.47 106.23 213.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-273",
    points: "76.31 195.74 74.08 194.45 74.08 196.9 76.31 198.19 76.31 195.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "82 204.97 79.99 203.82 79.99 206.27 82 207.42 82 204.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "84.84 206.62 82.84 205.46 82.84 207.91 84.84 209.07 84.84 206.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "77.15 204.62 79.15 205.78 79.15 203.33 77.15 202.17 77.15 204.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "107.08 219.45 107.08 221.9 112.06 224.78 112.06 222.33 107.08 219.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "106.23 218.97 85.69 207.1 85.69 209.55 106.23 221.42 106.23 218.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "76.31 201.69 74.08 200.4 74.08 202.85 76.31 204.13 76.31 201.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-280",
    points: "82 210.92 79.99 209.77 79.99 212.22 82 213.37 82 210.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "84.84 212.56 82.84 211.41 82.84 213.86 84.84 215.02 84.84 212.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "77.15 210.57 79.15 211.73 79.15 209.28 77.15 208.12 77.15 210.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "107.08 225.4 107.08 227.85 112.06 230.73 112.06 228.28 107.08 225.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "106.23 224.92 85.69 213.05 85.69 215.5 106.23 227.37 106.23 224.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "76.31 207.64 74.08 206.35 74.08 208.8 76.31 210.09 76.31 207.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "82 216.87 79.99 215.72 79.99 218.17 82 219.32 82 216.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "84.84 218.52 82.84 217.36 82.84 219.81 84.84 220.97 84.84 218.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-288",
    points: "77.15 216.52 79.15 217.68 79.15 215.23 77.15 214.07 77.15 216.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "107.08 231.35 107.08 233.81 112.06 236.68 112.06 234.23 107.08 231.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "106.23 230.87 85.69 219 85.69 221.45 106.23 233.32 106.23 230.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "76.31 213.59 74.08 212.3 74.08 214.75 76.31 216.03 76.31 213.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "70.99 219.43 70.99 78.76 109.9 101.42 109.9 242.11 70.99 219.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M66.78,71.43V221.85l47.34,27.6V99ZM109.9,242.11,71,219.43V78.76l38.91,22.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-294",
    points: "66.78 71.43 66.78 221.85 114.12 249.45 114.12 98.99 66.78 71.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "66.78 71.43 66.78 122.56 114.12 150.16 114.12 98.99 66.78 71.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "0 98.18 114.21 188.66 114.21 174 0 83.52 0 98.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "0 96.78 114.21 187.26 114.21 172.6 0 82.12 0 96.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M2.18,83.85l8,21L23.26,115.2l-8-21Zm28.23,22.36,8,21,13.1,10.37-8-21ZM100,161.31,86.87,150.94l8,21L108,182.29ZM58.64,128.57l8,21,13.1,10.38-8-21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "114.04 187.91 114.2 188.99 199.26 88.77 199.26 73.49 114.04 173.9 114.04 187.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "114.04 186.15 114.2 187.23 199.26 87.01 199.26 71.73 114.04 172.15 114.04 186.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M146.45,149.23l7.15-8.43L156,122.67l-7.15,8.43Zm15.42-18.17,7.16-8.43,2.43-18.14-7.16,8.43Zm15.43-18.18,7.16-8.43,2.42-18.14-7.15,8.43Zm17.85-36.31L192.73,94.7,199.26,87V71.73ZM131,167.41l7.15-8.43,2.43-18.14-7.15,8.43Zm-15.43,18.18,7.16-8.43L125.18,159,118,167.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "0.11 94.95 114.15 147.58 114.15 132.92 0.11 80.3 0.11 94.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "0.11 93.37 114.15 145.99 114.15 131.34 0.11 78.72 0.11 93.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M75.38,113.45l8,18.34,13.09,6-8-18.34Zm-28.23-13,8,18.34,13.09,6-8-18.34Zm56.46,26.06,8,18.34,2.56,1.17V131.34ZM18.92,87.4l8,18.34,13.09,6L32,93.44ZM.11,78.72V93.37l11.66,5.38-8-18.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "114.13 147.55 199.69 157.52 199.69 142.86 114.13 132.9 114.13 147.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-303",
    points: "114.13 145.97 199.69 155.94 199.69 141.28 114.13 131.31 114.13 145.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M162.94,137l6.85,15.43L182.88,154,176,138.52Zm-28.23-3.29,6.85,15.43,13.09,1.53-6.85-15.43Zm56.45,6.58L198,155.71l1.68.2V141.28Zm-77-9V146l12.3,1.43L119.57,132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M86.18,257v-1H13.74v1.79h0c-.44,3.27,1.3,6.46,5.31,8.77l16.63,9.61c8,4.59,21.87,4,31.06-1.29l11.89-6.87C84.09,264.91,86.66,260.81,86.18,257Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M35.69,273.36l-16.63-9.61c-8-4.59-7-12.62,2.23-17.93L33.18,239c9.19-5.31,23.09-5.88,31.06-1.29l16.63,9.6c8,4.6,7,12.63-2.23,17.94l-11.89,6.86C57.56,277.38,43.65,278,35.69,273.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M78.64,264.51l-11.89,6.86c-9.19,5.31-23.1,5.89-31.06,1.29l-16.63-9.6c-3.37-1.95-5.12-4.51-5.34-7.22-.22,3.11,1.52,6.11,5.34,8.31l16.63,9.6c8,4.6,21.87,4,31.06-1.28l11.89-6.87c5.3-3.06,7.86-7,7.56-10.71C86,258.25,83.42,261.75,78.64,264.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M86.18,261.21v-1h0c-.43,3.23-3,6.53-7.53,9.16l-11.89,6.86c-9.19,5.31-23.1,5.89-31.06,1.29l-16.63-9.6c-3.32-1.92-5.06-4.44-5.32-7.1V262h0c-.44,3.27,1.3,6.46,5.31,8.78l16.63,9.6c8,4.6,21.87,4,31.06-1.29l11.89-6.86C84.09,269.1,86.66,265,86.18,261.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M57.24,200.53H43L27.55,252.87h0c0,.06,0,.12,0,.19,0,7.26,10.11,13.14,22.58,13.14s22.58-5.88,22.58-13.14c0-.07,0-.13,0-.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M57.24,200.56c0,2.28-3.18,4.14-7.11,4.14S43,202.84,43,200.56s3.19-4.15,7.11-4.15S57.24,198.27,57.24,200.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M72.71,252.87l-3.07-10.39c0,.13,0,.25,0,.38,0,6.27-8.75,11.36-19.53,11.36s-19.52-5.09-19.52-11.36c0-.13,0-.25,0-.38l-3.08,10.39h0c0,.06,0,.12,0,.19,0,7.26,10.11,13.14,22.58,13.14s22.58-5.88,22.58-13.14c0-.07,0-.13,0-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M63.44,221.49c0,.07,0,.14,0,.22,0,4.28-6,7.75-13.32,7.75S36.81,226,36.81,221.71a1.9,1.9,0,0,1,0-.25l-3.14,10.6a2,2,0,0,1,0,.22c0,5.28,7.35,9.56,16.42,9.56s16.42-4.28,16.42-9.56a1.41,1.41,0,0,1,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M57.24,200.53h0v0c0,2.28-3.18,4.14-7.11,4.14S43,202.84,43,200.56v0h0L39.92,211v.1c0,3.29,4.57,6,10.21,6s10.22-2.66,10.22-6V211Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M56,200.32c0,1.65-2.61,3-5.84,3s-5.84-1.33-5.84-3,2.62-3,5.84-3S56,198.67,56,200.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M56,200.32c0,1.65-2.61,3-5.84,3s-5.84-1.33-5.84-3,2.62-3,5.84-3S56,198.67,56,200.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M56.07,198.67l-4.6.88,4.9,52.37h0a1.16,1.16,0,0,0,0,.18c1.37,7.13,5.75,12.28,9.78,11.5s6.19-7.19,4.82-14.32c0-.06,0-.11,0-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M45.18,198.67l4.6.88-4.9,52.37h0a1.16,1.16,0,0,0,0,.18c-1.37,7.13-5.75,12.28-9.78,11.5s-6.19-7.19-4.82-14.32c0-.06,0-.11,0-.17h0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorResource);
export default __webpack_public_path__ + "static/media/error-resource.87e938992aff4723455126499b83c10c.svg";
export { ForwardRef as ReactComponent };